import { Box, Skeleton } from '@mantine/core'

export function MyCampaignsSkeleton() {
  return (
    <Box style={{ width: '100%' }} data-testid="my-campaigns-skeleton">
      <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
        <Skeleton height="2rem" width="8.67rem" radius="1rem" />
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', marginTop: '1.5rem' }}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            gap: '1rem',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
            paddingInline: '0.25rem'
          }}
        >
          <Skeleton height="2rem" width="29%" />
          <Skeleton height="2rem" width="29%" />
          <Skeleton height="2rem" width="19%" />
          <Skeleton height="2rem" width="12.08%" />
          <Skeleton height="2rem" width="5.42%" />
        </Box>
        <Skeleton height="3rem" width="100%" />
        <Skeleton height="3rem" width="100%" />
        <Skeleton height="3rem" width="100%" />
        <Skeleton height="3rem" width="100%" />
        <Skeleton height="3rem" width="100%" />
        <Skeleton height="3rem" width="100%" />
      </Box>
    </Box>
  )
}
